module.exports = __webpack_public_path__ + "img/card-icon.3c6e3e4b.svg";